import { gql } from '@apollo/client'

export default gql(`
	mutation add_postscript_to_answer($id: ID!, $text: String!) {
		add_postscript_to_answer(id: $id, text: $text) {
			id
		}
	}
`)
